import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useRecapitulationReportUIContext } from "./RecapitulationReportUIContext";
import { RecapitulationReportFilter } from "./recapitulation-report-table/recapitulation-report-filter/RecapitulationReportFilter";
import {
  fetchRecapitulationReports,
} from "../../_redux/recapitulation-report/recapitulationReportAction";
import { exportRecapitulation } from "../../_redux/recapitulation-report/recapitulationReportCrud";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import RecapitulationReportTable from "./recapitulation-report-table/RecapitulationReportTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import RecapitulationExportFileModal from "./recapitulation-export-file-modal/RecapitulationExportFileModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";

export const RecapitulationReportCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    recapitulationReport: false,
    confirmation: false,
    exportRecapitulation: false,
  });
  const [currentItem, setCurrentItem] = useState({});
  const [openFilter, setOpenFilter] = useState(false);

  // * ConsolidationReport UI Context
  const recapitulationReportUIContext = useRecapitulationReportUIContext();
  const recapitulationReportUIProps = useMemo(() => {
    return {
      queryParams: recapitulationReportUIContext.queryParams,
      setQueryParams: recapitulationReportUIContext.setQueryParams,
      openEditRecapitulationReportPage:
        recapitulationReportUIContext.openEditRecapitulationReportPage,
      openConsolidationReportFilePage:
        recapitulationReportUIContext.openRecapitulationReportFilePage
    };
  }, [recapitulationReportUIContext]);

  // * Getting current state of consolidationReport list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminRecapitulationReport,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke ConsolidationReport Action
    dispatch(fetchRecapitulationReports(recapitulationReportUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recapitulationReportUIProps.queryParams, dispatch]);

  const [btnDisable, setDisable] = useState(false);
  const exportRecapitulationData = async value => {
    setDisable(true);
    await exportRecapitulation(recapitulationReportUIProps.queryParams)
      .then(res => {
        const url = URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `${value.filename}.xlsx`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDisable(false);
      })
      .catch(err => {
        console.log(`err`, err);
        toast.error("Gagal export data Rekapitulasi");
      })
      .then(() => {
        setOpenModal(prev => ({ ...prev, exportRecapitulation: false }));
      });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* EXPORT RECAPITULATION */}
      <RecapitulationExportFileModal
        btnDisable={btnDisable}
        show={openModal.exportRecapitulation}
        onHide={() => setOpenModal(prev => ({ ...prev, exportRecapitulation: false }))}
        onClick={exportRecapitulationData}
        title="Export Data Rekapitulasi"
        initialValues={{}}
      />
      <Card>
        <CardHeader title="Laporan Rekapitulasi">
          <CardHeaderToolbar>
            <button
              className="btn btn-outline-dark mx-1"
              onClick={() => setOpenModal(prev => ({ ...prev, exportRecapitulation: true }))}
            >
              Export Lembaga
            </button>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div id="collapse-filter-report">
              <RecapitulationReportFilter />
            </div>
          </Collapse>
          <RecapitulationReportTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={recapitulationReportUIProps.queryParams}
            setQueryParams={recapitulationReportUIProps.setQueryParams}
            openEditRecapitulationReportPage={
              recapitulationReportUIProps.openEditRecapitulationReportPage
            }
            setCurrentItem={setCurrentItem}
            setOpenModal={setOpenModal}
          />
        </CardBody>
      </Card>
    </>
  );
};
